import { thunk } from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import { rootReducer } from './rootReducer';
import { persistStore } from 'redux-persist';
const store = createStore(rootReducer,applyMiddleware(thunk))
export const persistor = persistStore(store);
export default store; 